import React, { useState } from 'react';
import MultiFeatureCard from '../../../../../../components/Common/Card/MultiOptionsCard/MultiFeatureCard';
import LowerSampleSizeFooter from '../../../../../../components/Common/LowerSampleSizeFooter';
import OnlineReviewByPropertiesBarGraph from './OnlineReviewByPropertiesBarGraph';
import OnlineReviewGraphTable from './OnlineReviewGraphTable';
import OnlineReviewTable from './OnlineReviewTable';

const OnlineReviewByProperties = props => {
  const { item, lowSampleSize } = props;


  const [selectedMetricOptions, setSelectedMetricOptions] = useState([])
  function renderContent(type) {
    switch (type) {
      case 'TABLE':
        return (
          <OnlineReviewTable lowSampleSize={lowSampleSize} setSelectedMetricOptions={setSelectedMetricOptions} />
        );
      case 'TIME':
        return <OnlineReviewGraphTable lowSampleSize={lowSampleSize} selectedMetricOptions={selectedMetricOptions} />
      case 'BAR':
        return (
          <OnlineReviewByPropertiesBarGraph selectedMetricOptions={selectedMetricOptions} />
        );
    }
  }

  return (
    <MultiFeatureCard
      title={item?.title}
      subTitle={item?.subTitle}
      style={{ childContainer: { paddingVertical: 20 } }}
      enableActionBtn={item?.enableActionBtn}
      enableSwitchTab={item?.enableSwitchTab}
      switchOptions={item?.switchOptions}
      renderContent={(activeSwitch) => {
        return renderContent(activeSwitch)
      }}
      renderFooter={() => <LowerSampleSizeFooter size={lowSampleSize} />} />
  )
};

export default OnlineReviewByProperties;
